module.exports = __webpack_public_path__ + "static/pointSaleImage-19b66c13c793f779c1a2dce7af7c34ee.png";